export default function({ url, retries, timeout, fallbackUrl, check }) {
  function download(trial, resolve, reject) {
    const nthTry = trial + 1

    let _url
    if (nthTry < retries) {
      _url = url
    } else if (nthTry === retries) {
      _url = fallbackUrl
    } else {
      reject(new Error("unable to download"))
      return
    }

    $.ajax({
      url: _url,
      dataType: "script",
      timeout,
      success() {
        resolve()
      },
      error() {
        download(nthTry, resolve, reject)
      },
    })
  }

  return new Promise((resolve, reject) => {
    if (check()) {
      resolve()
    } else {
      download(0, resolve, reject)
    }
  })
}
